import React from 'react'

export default function SoupIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_522_2239)">
        <path
          d="M4.8442 12.75H10.6775M12.1359 7.5L13.5942 4M10.24 2.25C10.3975 2.30833 10.7067 2.55917 10.6775 3.04333C10.6425 3.5275 10.135 3.74333 10.0942 4.22167C10.065 4.67667 10.2925 4.945 10.52 5.16667M7.32336 2.25C7.48086 2.30833 7.79003 2.55917 7.75503 3.04333C7.72586 3.5275 7.21253 3.74333 7.18336 4.22167C7.14836 4.67667 7.37586 4.945 7.60336 5.16667M4.4067 2.25C4.5642 2.30833 4.87336 2.55917 4.8442 3.04333C4.8092 3.5275 4.3017 3.74333 4.26086 4.22167C4.2317 4.67667 4.4592 4.945 4.69253 5.16667M7.76086 12.75C9.15325 12.75 10.4886 12.1969 11.4732 11.2123C12.4577 10.2277 13.0109 8.89239 13.0109 7.5H2.51086C2.51086 8.89239 3.06399 10.2277 4.04855 11.2123C5.03312 12.1969 6.36848 12.75 7.76086 12.75Z"
          stroke="#6C6C6C"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2239">
          <rect width="14" height="14" fill="white" transform="translate(0.760864 0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
